import MyLots from './MyLots.jsx';

export default MyLots;
